<template>
    <div>
        <div class="w-100 text-sm-start text-center">
            <img src="@/assets/images/avatar.jpg" :alt="datas.about.name + ', ' + datas.about.function" class="d-sm-none img-thumbnail rounded-circle w-75 shadow" style="max-width:200px;" >

            <h1 id="about-title" class='text-secondary'>{{ datas.about.name }}</h1>

            <span class='text-primary'>
                {{ new Date().getFullYear() - datas.about.informations.birth }} ans, {{ datas.about.informations.location }}<br />
            </span>
        </div>


        <div class="my-5">
            <h2 class="text-success jetbrainsmono writer-wrapper">
                <span class="text-secondary">&gt;</span> {{datas.about.function }}
            </h2>
        </div>

        <div class="d-flex">
            <div class="pt-2">
                <i class="bi bi-chat-left-quote-fill me-3"></i>
            </div>
            <div class="">
                <p style="line-height: 2;">
                    {{ datas.about.introduction1 }}<br />
                    {{ datas.about.introduction2 }}<br />
                    {{ datas.about.introduction3 }}<br />
                </p>
            </div>
        </div>

        <div class="d-flex text-primary">
            <div class="pt-1">
                <i class="bi bi-stack me-3"></i>
            </div>
            <div class="">
                <p>
                    <span class="text-primary">{{ datas.about.favorite_stack }}</span>
                </p>
            </div>
        </div>


        <div class='mt-5'>
            <router-link :to="'/sheet'" class='shadow btn me-4 mb-4 text-capitalize btn-danger'>
                <i class="bi bi-filetype-pdf me-1"></i> Télécharger mon CV
            </router-link>

            <a class='shadow btn btn-success me-4 mb-4 text-lowercase' :href="'mailto:'+datas.about.mail">
                <i  class="bi bi-envelope-fill me-1"></i> cv@tfrichet.fr
            </a>

            <a class='shadow btn btn-primary me-4 mb-4 text-capitalize' :href="datas.about.linkedin" target="_blank" rel="noopener noreferrer">
                <i  class="bi bi-linkedin me-1"></i> Linkedin
            </a>

            <a class='shadow btn btn-primary me-4 mb-4 text-capitalize' :href="datas.about.github" target="_blank" rel="noopener noreferrer">
                <i  class="bi bi-github me-1"></i> Github
            </a>

            <a class='shadow btn btn-portlatch me-4 mb-4 text-capitalize' :href="datas.about.portlatch" :title="datas.about.portlatch_title" target="_blank" rel="noopener">
                <svg class="portlatch-icon me-1" xmlns="http://www.w3.org/2000/svg" viewBox="4.5 4.5 23 23" aria-hidden="true"><path d="M25.6 13.4A10 10 0 1 0 25.6 18.6" fill="none" stroke="currentColor" stroke-width="2.2"/><rect x="13.6" y="13.6" width="4.8" height="4.8" rx="1" fill="currentColor"/></svg> Portlatch
            </a>

            <a class='shadow btn btn-dark me-4 mb-4 text-capitalize' href="https://formation.tfrichet.fr" target="_blank" rel="noopener noreferrer">
                <i  class="bi bi-mortarboard-fill me-1"></i> Supports de formation
            </a>






        </div>


    </div>
</template>

<script>
export default {
    name: 'SectionAbout',
    props : {
        section : { type : Object, required : true }
    },
    data : function() {
        return {

        }
    }
}
</script>

<style scoped>
.btn-portlatch {
    color: #fff;
    background-color: #545AC2;
    border-color: #545AC2;
}

.btn-portlatch:hover,
.btn-portlatch:focus,
.btn-portlatch:active {
    color: #fff;
    background-color: #474ca5;
    border-color: #474ca5;
}

.portlatch-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.125em;
}

.btn-portlatch:focus {
    box-shadow: 0 0 0 0.25rem rgba(84, 90, 194, 0.5);
}

@media only screen and (max-width: 1100px) {
    .writer-wrapper {
        font-size:1.5rem;
        height:2.5rem;
    }
}

.is-typed span.typed {
  color: black;
}

.is-typed span.cursor {
  display: inline-block;
  width: 3px;
  background-color: black;
  animation: blink 1s infinite;
}

.is-typed span.underscore {
  display: inline-flex;
  width: 10px;
  height: 1px;
  align-items:flex-end;
  background-color: black;
  animation: blink 1s infinite;
}

.is-typed span.cursor.typing {
  animation: none;
}

@keyframes blink {
  49% {
    background-color: black;
  }
  50% {
    background-color: transparent;
  }
  99% {
    background-color: transparent;
  }
}


.blink_me {
  animation: blinker 1s steps(1, end) infinite;
}

@keyframes blinker {
  50% { opacity: 0; }
}

</style>
